/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { Course as CourseController } from '../../../api'
import { Container, Image, Button } from 'semantic-ui-react'
import { map } from 'lodash'
import { image } from '../../../assets'
import { Course } from '../../../components/Web/Courses'
import "./Courses.scss"

const courseController = new CourseController();

export function Courses() {
  const [courses, setCourses] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  const isCurrentLastPage = pagination?.page === pagination?.pages;

  useEffect(() => {
    (async () => {
      try {
        const response = await courseController.getCourses({ page, limit: 9 });
        setPagination({
          page: response.page,
          pages: response.pages,
        })

        if (!courses) setCourses(response.docs);
        else setCourses([...courses, ...response.docs]);

      } catch (error) {
        console.error(error);
      }
    })();
  }, [page]);

  const loadMore = () => {
    setPage((prevState => prevState + 1));
  }

  return (
    <Container className='courses-page'>
      <div className='courses-page__info'>
        <div class="courses-page__info-image">
          <Image src={image.academyLogo} />
        </div>
        <div class="courses-page__info-text">
          <h2>
            Descubre la amplia selección de cursos de programación en línea que tenemos para ti en México.  < br />
            Conviértete en un programador Full Stack y accede a un mundo de oportunidades.  < br />
            ¡Únete a nosotros y empieza a aprender hoy mismo!
          </h2>
        </div>
      </div>
      <div className='courses'>
        {map(courses, (course) => (
          <div key={course._id} className='courses__item'>
            <Course course={course} />
          </div>
        ))}
      </div>

      {!isCurrentLastPage && (
        <div className='more'>
          <Button primary onClick={loadMore}>
            Cargar mas...
          </Button>
        </div>
      )}

    </Container>
  )
}
